export default __webpack_public_path__ + "static/media/icon_refresh_h.f7c471b7.png";